import { useState } from 'react';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'O que é empréstimo consignado?',
      answer: 'O empréstimo consignado é uma modalidade de crédito onde as parcelas são descontadas automaticamente do seu salário ou benefício do INSS. Por ter essa garantia de pagamento, oferece as menores taxas de juros do mercado e não exige consulta ao SPC/Serasa.',
    },
    {
      question: 'Quem pode contratar um empréstimo consignado?',
      answer: 'Podem contratar empréstimo consignado: aposentados e pensionistas do INSS, servidores públicos federais, estaduais e municipais, trabalhadores CLT de empresas conveniadas, e militares das Forças Armadas. É necessário ter margem consignável disponível.',
    },
    {
      question: 'Qual é a taxa de juros do empréstimo consignado?',
      answer: 'As taxas variam conforme o tipo de convênio e perfil do cliente. Para aposentados INSS, as taxas começam a partir de 1,49% ao mês. Para servidores públicos e CLT, a partir de 1,69% ao mês. São as menores taxas do mercado de crédito.',
    },
    {
      question: 'Quanto tempo demora para o dinheiro cair na conta?',
      answer: 'Após a aprovação do crédito e assinatura do contrato, o dinheiro é liberado em até 24 horas úteis na sua conta bancária. Em alguns casos, a liberação pode ser ainda mais rápida, no mesmo dia.',
    },
    {
      question: 'O que é portabilidade de crédito consignado?',
      answer: 'A portabilidade permite transferir seu empréstimo consignado de outra instituição para a Carbone, obtendo taxas menores e reduzindo o valor das parcelas em até 40%. O processo é gratuito, 100% digital e não há custos de transferência.',
    },
    {
      question: 'Como funciona o refinanciamento?',
      answer: 'No refinanciamento, você renegocia seu contrato atual e pode receber a diferença em dinheiro na conta. É ideal para quitar dívidas com juros altos, fazer reformas ou realizar projetos. Você mantém o desconto em folha com parcelas menores.',
    },
    {
      question: 'Preciso ter conta no banco para contratar?',
      answer: 'Não é necessário ter conta em um banco específico. O dinheiro pode ser depositado na conta de sua preferência, em qualquer instituição bancária. Você escolhe onde quer receber o valor aprovado.',
    },
    {
      question: 'Qual é o prazo máximo para pagar?',
      answer: 'O prazo varia conforme o tipo de empréstimo e convênio. Para empréstimo consignado INSS, o prazo pode chegar até 84 meses (7 anos). Para servidores públicos e CLT, até 96 meses (8 anos). Você escolhe o prazo que melhor se adequa ao seu orçamento.',
    },
    {
      question: 'Posso antecipar o pagamento do empréstimo?',
      answer: 'Sim! Você pode quitar antecipadamente seu empréstimo consignado a qualquer momento, com desconto proporcional dos juros. Não há multa ou taxa para antecipação. Entre em contato conosco para calcular o valor da quitação.',
    },
    {
      question: 'O empréstimo consignado tem seguro?',
      answer: 'Sim, todos os contratos incluem seguro prestamista, que protege você e sua família em casos de morte ou invalidez permanente. O seguro quita automaticamente o saldo devedor, sem custos adicionais para os beneficiários.',
    },
    {
      question: 'Como sei se tenho margem consignável disponível?',
      answer: 'A margem consignável é o limite de desconto permitido no seu salário ou benefício (geralmente 35% para empréstimos e até 40% incluindo cartão). Nossa equipe verifica gratuitamente sua margem disponível. Basta entrar em contato conosco.',
    },
    {
      question: 'Quais documentos são necessários?',
      answer: 'Os documentos básicos são: RG, CPF, comprovante de residência atualizado e comprovante de renda (contracheque ou extrato do INSS). Em alguns casos, podem ser solicitados documentos adicionais. Todo o processo pode ser feito digitalmente.',
    },
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-24 bg-gradient-to-br from-navy-50 via-white to-gold-50" id="faq">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-gold-500 font-semibold text-sm uppercase tracking-wide">
            Tire suas dúvidas
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-navy-900 mt-3 mb-4">
            Perguntas Frequentes
          </h2>
          <p className="text-xl text-navy-600 max-w-2xl mx-auto">
            Reunimos as principais dúvidas sobre empréstimo consignado e nossos serviços
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white border-2 border-navy-100 rounded-xl overflow-hidden transition-all duration-300 hover:border-gold-400 hover:shadow-lg"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between gap-4 p-6 text-left cursor-pointer"
              >
                <div className="flex items-start gap-4 flex-1">
                  <div className="w-10 h-10 bg-gold-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-question-line text-gold-600 text-xl"></i>
                  </div>
                  <h3 className="text-lg font-bold text-navy-900 flex-1">
                    {faq.question}
                  </h3>
                </div>
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`${
                      openIndex === index ? 'ri-subtract-line' : 'ri-add-line'
                    } text-2xl text-navy-700 transition-transform duration-300`}
                  ></i>
                </div>
              </button>

              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-6 pb-6 pl-20">
                  <p className="text-navy-600 leading-relaxed">{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center bg-white border-2 border-gold-200 rounded-2xl p-8">
          <div className="w-16 h-16 bg-gold-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <i className="ri-customer-service-2-line text-gold-600 text-3xl"></i>
          </div>
          <h3 className="text-2xl font-bold text-navy-900 mb-3">
            Não encontrou sua resposta?
          </h3>
          <p className="text-navy-600 mb-6">
            Nossa equipe está pronta para esclarecer todas as suas dúvidas
          </p>
          <a
            href="https://wa.me/5519971344445?text=Olá! Tenho uma dúvida sobre os serviços da Carbone."
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-gold-500 hover:bg-gold-600 text-navy-900 font-bold px-8 py-4 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-whatsapp-line text-xl"></i>
            Falar com Especialista
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
